import type { LayoutCanvasWorkspaceProps } from "./LayoutCanvasWorkspace"
import { LayoutCanvasWorkspace } from "./LayoutCanvasWorkspace"
import { type LayoutPreviewRuntimeToolbarProps, LayoutPreviewRuntimeToolbar } from "./LayoutPreviewRuntimeToolbar"
import { LayoutModeToggle } from "./LayoutModeToggle"
import type { ReportDesignerValidationIssue } from "./reportDesignerValidation"
import { ValidationSummaryCard } from "./ValidationSummaryCard"
import type { WidgetPropertiesCardProps } from "./WidgetPropertiesCard"
import { WidgetPropertiesCard } from "./WidgetPropertiesCard"

export interface LayoutEditorTabContentProps {
  layoutViewMode: "design" | "preview"
  onLayoutViewModeChange: (mode: "design" | "preview") => void
  validationIssues: ReportDesignerValidationIssue[]
  previewToolbarProps: LayoutPreviewRuntimeToolbarProps
  workspaceProps: LayoutCanvasWorkspaceProps
  widgetPropertiesProps: WidgetPropertiesCardProps
}

export function LayoutEditorTabContent({
  layoutViewMode,
  onLayoutViewModeChange,
  validationIssues,
  previewToolbarProps,
  workspaceProps,
  widgetPropertiesProps,
}: LayoutEditorTabContentProps) {
  return (
    <div className="space-y-4">
      <LayoutModeToggle mode={layoutViewMode} onModeChange={onLayoutViewModeChange} />

      <ValidationSummaryCard
        title="Layout Guardrails"
        issues={validationIssues}
        category="widget"
        emptyMessage="All widget bindings and layout references look valid."
      />

      {layoutViewMode === "preview" ? <LayoutPreviewRuntimeToolbar {...previewToolbarProps} /> : null}

      <div className="grid gap-4 xl:grid-cols-[300px_minmax(0,1fr)_360px]">
        <LayoutCanvasWorkspace {...workspaceProps} />
        <WidgetPropertiesCard {...widgetPropertiesProps} />
      </div>
    </div>
  )
}
